import { Circ, Expo, TimelineLite } from "gsap";
import * as HLF from "html-living-framework";
import * as PIXI from "pixi.js";
import {Ease} from "../core/Animatable";
import {Container} from "../core/Container";
import {array} from "../core/Reflection";
import {Sprite} from "../core/Sprite";
import { Button, OutlinedButton } from "../gameobjects/Button";
import {AbstractGameState} from "./AbstractGameState";

import { random } from "html-living-framework/lib/Utils/ArrayUtils";
import { Application } from "../Application";
import LightsOutGameModel from "../data/LightsOutGameModel";
import * as VO from "../data/VO";
import { Elmo } from "../gameobjects/Elmo";
import { Grover } from "../gameobjects/Grover";
import { LightsOutIntroLayout } from "../layout/LightsOutIntroLayout";
import { CaptionManager } from "../managers/CaptionManager";
import { LightsOutElmoBathroomScreen } from "./LightsOutElmoBathroomScreen";
import { LightsOutElmoBedroomScreen } from "./LightsOutElmoBedroomScreen";
import { LightsOutElmoLivingRoomScreen } from "./LightsOutElmoLivingRoomScreen";

export class LightsOutIntroScreen extends AbstractGameState {

    public static readonly NAME = "LightsOutIntroScreen";
    public static visited: boolean = false;

    public readonly bg = this.addChild(new Sprite());
    public readonly elmo = this.addChild(new Elmo());
    public readonly grover = this.addChild(new Grover());
    public readonly skipButton = this.addChild(new Button());
    public readonly homeButton = this.addChild(new OutlinedButton());
    protected analyticsScreenName: string = "Lights Out";
    protected analyticsRoundName = "Lights Out";

    public init(pSize: PIXI.Point, pData: {}) {
        LightsOutIntroLayout.call(this);
        this.skipButton.onClick.add(() => {
            LightsOutIntroScreen.visited = true;
            this.gotoNextState(random([LightsOutElmoBathroomScreen.NAME, LightsOutElmoLivingRoomScreen.NAME]), {fromIntro: true});
        });
        this.homeButton.onClick.add(() => {
            this.trackEvent("gameMenuClick",
            {label: `MenuButton_Home_ScreenName_${this.analyticsScreenName}`},
            );
            this.gotoNextState("MainMenu");
        });
        this.homeButton.clickSfx = "buttonclick";
        this.skipButton.clickSfx = "buttonclick";

        this.skipButton.visible = false;

        this.trackEvent("gameRoundStart",
        {
            label: `Round Number_${Application.instance.round}_Round Name_${this.analyticsRoundName}_ScreenName_${this.analyticsScreenName}`,
        });
        LightsOutGameModel.roundStartTime = new Date().valueOf();
        super.init(pSize);
    }

    public animateIn(pOnComplete: () => void) {
        super.animateIn(pOnComplete);

        const bgm = HLF.Application.instance.audio.getAudioTrack("lights_out_loop", HLF.AudioCategory.BGM) ?? HLF.Application.instance.audio.createAudioTrack("lights_out_loop", HLF.AudioCategory.BGM);
        if (bgm.isPlaying() === false) {
            bgm.setLooped(true);
            bgm.play();
        }

        this.elmo.Wave();
        Application.instance.voiceover.playVO([...VO.LO_INTRO01, ...VO.LO_INTRO02, VO.LO_INTRO03, VO.LO_INTRO04], () => {
            LightsOutIntroScreen.visited = true;
            this.gotoNextState(random([LightsOutElmoBathroomScreen.NAME, LightsOutElmoLivingRoomScreen.NAME]), {fromIntro: true});
        });
    }

    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);
        this.position.set((pSize.x - 1024) / 2, 0);
    }

    public update(pDeltaTime: number) {
        super.update(pDeltaTime);
        this.elmo.update(pDeltaTime);
        this.grover.update(pDeltaTime);
    }
}
